export const LIST_LABEL = 'last_visited_products';
